<template>
  <div class="about">

    <div class="p-2 ml-2 bg-light gothic fontSizeDot9 border-top border-bottom">
      <router-link :to="{ name: 'tinkHome' }" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          처음
        </span>  
      </router-link>
      &gt;
      <b-dropdown text="Data 서비스" size="sm" role="menu" toggle-class="pl-2 pr-2 pt-dot1 pb-dot1">
        <b-dropdown-item :to="{ name: 'tinkAbout' }">
          Tinkable 소개
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutKit' }">
          IoT 키트
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutCore' }">
          Core 프로그램
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkAboutData' }" :active="true">
          Data 서비스
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkTos' }">
          서비스 약관
        </b-dropdown-item>
        <b-dropdown-item :to="{ name: 'tinkPrivacy' }">
          개인정보 처리방침
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <h1 class="documentTitle" v-if="!presentationMode">
      Tinkable Data 서비스 소개
    </h1>

    <div class="contentBody">
      <h2><a name="kit">개요</a></h2>
      <div class="extra gothic">
        <ul>
          <li>Data 서비스 사용설명서</li>
          <li>Data 서비스 퀵메뉴얼</li>
        </ul>
      </div>
      <p>서비스에 대한 간력한 설명.<p>

      <h2>시스템 구성</h2>
      <p>시스템 구성 소개.</p>

      <h2>소프트웨어 구성</h2>
      <p>시스템 구성 소개.</p>

      <h2>사용하는 패키지</h2>
      <p>시스템 구성 소개.</p>

      <h2>기능 명세</h2>
      <p>시스템 구성 소개.</p>
      <h2>개발 역사</h2>
      <h3>v1.0</h3>
      <h3>v0.2</h3>
      <h4>
          Ui에 추가된 기능
      </h4>
      <ul>
        <li>발표모드가 추가되었습니다. 모든 페이지에서 우측 상단 메뉴에서 발표 모드를 선택하면 내용 부분만 표시됩니다. 종료하면 돌아옵니다.</li>
        <li>키보드 액션이 추가되었습니다. m 또는 Alt+m을 누르면 우측 상단 메뉴가 표시되고, p또는 alt+p를 누르면 발표모드로 들어갑니다. esc를 누르면 발표모드에서 나옵니다.</li>
        <li>실행결과 메시지가 모달에서 토스터로 바뀌었습니다. 토스터 메시지는 사용자가 클릭할 필요가 없으며 몇 초 뒤에 자동으로 삭제됩니다.</li>
        <li>경로 표시 부분이 좀더 자세하게 변경되었습니다. 기기목록이 경로에 포함됩니다.</li>
      </ul>
      <h4>
          기기 개요 페이지
      </h4>
      <ul>
        <li>지도에서 기기의 위치를 지정할 수 있습니다.</li>
        <li>지도에서 구글 자동완성으로 장소나 주소를 검색하고 바로 그 장소나 주소를 클릭하면 해당 장소 정보가 같이 저장됩니다.</li>
        <li>장소 정보에 사진이 있는 경우에는 기기 사진으로 바로 사용할 수 있도록 화면에 표시해줍니다.</li>
        <li>기기의 위치를 지정하면 지도에 마커로 기기 제목 및 센서 데이터가 표시됩니다. 당연히 실시간입니다.</li>
        <li>센서가 없는 기기는 바로 삭제할 수 있습니다.</li>
        <li>기기 정보를 저장할 때 지도의 위치, 줌인정도, 글자크기도 바로 지정할 수 있습니다.</li>
        <li>구글 지도는 지도 보기를 누르면 그 때에 생성됩니다. 지도 보기 누르기 전에는 과금이 안됩니다.</li>
      </ul>
      <h4>
          기기 목록 페이지
      </h4>
      <ul>
        <li>기기 목록 페이지에서 기기를 토글로 바로 끄고 켤 수 있습니다.</li>
        <li>기기 개요, 사진, 센서 데이터가 똑똑하게 잘 표시됩니다. 둘 다 있으면 (마우스 올리면)회전목마처럼 넘길 수 있고, 기기 개요나 사진이 없으면 아예 표시되지 않습니다. 상단 선택 목록에서 무엇을 우선할 지도 지정할 수 있고 기기 설정할 때 지정한 기본값도 스마트하게 적용됩니다. 기기 설정을 센서로 했는 데 추가된 센서가 없는 경우는 자동으로 표시되지 않습니다.</li>
        <li>기기 사진이 화면에 맞게 자동조절되어 표시됩니다. 긴 사진은 가운데 부분 위주로 crop되며 4:3 정도되는 비율이지만 한 줄에 표시되는 기기 수에 따라서 기기 사진의 비율도 계속 바뀝니다.</li>
        <li>장소 정보에 사진이 있는 경우에는 기기 사진으로 바로 사용할 수 있도록 화면에 표시해줍니다.</li>
        <li>기기 위치 정보를 누르면 자세한 정보가 표시됩니다.</li>
        <li>기기의 위도 경도가 도분초 단위로 표시되며 누르면 지도 탭으로 이동하고 지도에서 해당 기기가 선택된 상태로 표시됩니다.</li>
      </ul>
      <h4>
          지도 기능
      </h4>
      <ul>
        <li>지도 안에 팝업으로 기기의 제목, 센서 데이터가 표시됩니다. 여러 개를...</li>
        <li>팝업을 크기를 T+, T- 아이콘으로 조절할 수 있습니다</li>
        <li>현재 위치, 줌인 정도, 팝업 크기를 지도 설정으로 저장할 수 있습니다. 저장하면 다음에 다시 적용됩니다.</li>
        <li>지도 설정을 저장한 경우에 초기 상태 아이콘이 생기고 누르면 저장된 설정이 적용됩니다.</li>
        <li>모든 기기를 볼 수 있도록 확대 아이콘이 추가되었습니다.</li>
        <li>꺼진 기기는 남색, 켜진 기기는 파란색으로 표시됩니다. 선택한 기기는 빨강생입니다.</li>
        <li>기기 목록에서 기기를 선택하면 해당 기기가 화면에 없으면 해당 기기가 있는 위치로 자동 이동합니다. </li>
      </ul>
      <h4>
          로그인 안한 경우
      </h4>
      <ul>
        <li>로그인 안한 경우에는 모두 보기에는 문제가 없도록 했습니다.</li>
        <li>해당 기기의 작성자가 아닌 경우에는 지도 기능을 지원하지 않고 링크를 누르면 구글 지도로 연결되도록 했습니다.</li>
      </ul>
      <h3>v0.1 (2019-06-05)</h3>
        <p>
            적용된 모듈 정리하면 다음과 같습니다.
        </p>
        <ul>
          <li>firebase.auth: 구글 클라우드의 사용자 인증 서비스. 이 서비스의 회원 서비스의 기반</li>
          <li>firebase.firestore: 구글 클라우드의 collection, document 데이타베이스. 이 서비스의 데이터베이스로 사용.</li>
          <li>firebaseui-web: firebase.auth 기반으로 회원가입 및 로그인 등의 화면 서비스. 이 서비스의 회원 서비스의 기반</li>
          <li>firebase.hosting: 구글 클라우드의 호스팅 서비스. 개발된 웹사이트는 순수 HTML, JavaScript 방식입니다. 인코딩된 페이지가 firebase.hosting을 사용하여 서비스 됩니다.</li>
          <li>firebase.functions: 구글 클라아두의 이벤트 기반 스크립트 호스팅 서비스. 아두이노 기기에서 데이터를 저장, 외부 서비스에서 데이터를 가져갈 때, 스케쥴러 형식으로 프로그램을 실행할 때 사용.</li>
          <li>vue.js: 자바스크립트 웹 프레임워크. 이 프레임워크를 사용합니다.</li>
          <li>Vue CLI: vue.js를 위한 개발 도구. 개발된 페이지를 테스트하거나 firebase.hosting으로 배포할 때 사용.</li>
          <li>babel: Vue CLI에서 배포하기 전에 자바스크립트 코드를 컴파일합니다. 필요한 모듈은 넣고, 안쓰는 것은 빼고, 변수명은 짧게 바뀌고. 줄바꿈도 없어집니다.</li>
          <li>JSLint: Vue CLI에서 자바스크립트 코드의 문법을 검증할 때 사용합니다.</li>
          <li>vue Router: one paged applicaton을 위한 URL 라우팅 라이브러리. 이 모듈 사용하면 웹브라우저 주소 창은 바뀌는 데 페이지는 다시 읽기 되지 않게 One Page Application을 개발할 수 있습니다.</li>
          <li>vuejs-logger: vue.js용 개발 로깅. 개발 중에 사용.</li>
          <li>Bootstrap and BootstrapVue: CSS 프레임워크인 Bootstrap의 Vue 버전. UI 컴포넌트는 대부분 이걸 사용합니다. 그리고 Vue CLI에서 배포되기 전에 SCSS 형식으로 된 파일을 컴파일해서 CSS를 만듭니다. bootstrap에서 jquery를 일부 사용하므로 jquery도 포함되지만 bootstrap에서만 사용합니다. BootstrapVue는 portal-vue, popper.js 라이브러리와 sass.loader 컴파일러를 사용합니다.</li>
          <li>BootstrapVue: CSS 프레임워크인 Bootstrap의 Vue 버전. UI 컴포넌트는 대부분 이걸 사용합니다. 그리고 Vue CLI에서 배포되기 전에 SCSS 형식으로 된 파일을 컴파일해서 CSS를 만듭니다. </li>
          <li>vuex: vue.js를 위한 상태(데이터) 관리 라이브러리. 이걸 사용하면 로컬에 스토리지가 생겨서 모든 페이지와 컴포넌트에서 접속가능합니다.</li>
          <li>vuefire: firebase.firestore 데이터베이스를 위한 vue.js 라이브러리. 이 라이브러리를 사용하면 서버 데이터베이스에서 데이터가 변경되면 자동으로 로컬에 적용됩니다.</li>
          <li>vuexfire: firebase.firestore 데이터베이스를 위한 vuex 용 라이브러리. 이 라이브러리를 사용하면 서버 데이터베이스에서 데이터가 변경되면 자동으로 로컬 vuex에 적용됩니다.</li>
          <li>기타 모듈: vuexUtils.js, bootstrap toggle</li>
        </ul>
        <p>
            브라우저는 크롬, 사파리, 엣지, 파이어폭스를 지원할 예정입니다. 인터넷 익스플로러는 지원 안합니다.
            휴대폰, 타블렛, PC에서 자동으로 조절되도록 개발하고 있는 중. 페이지마다 테스트는 아직 안되어 있음.
        </p>
        <p>
            개발된 내역은 다음과 같습니다.
        </p>
        <ul>
          <li>로그인/로그아웃: 비밀번호, GOOGLE 계정을 사용하여 로그인/로그아웃. 둘 다 동시 사용 가능함. SNS로 가입하여 사용하다가 비밀번호 추가도 가능하고 비밀번호로 가입한 후에 SNS로 로그인도 가능.</li>
          <li>회원가입: 로그인 중에 자동으로 처리. 비밀번호 분실시 메일 발송으로 확인하는 기능.</li>
          <li>회원 정보 변경, 비밀번호 변경, 전자우편 주소 변경. 가입해서 사용하던 중에 전자우편 주소를 변경할 수 있습니다.</li>
          <li>전자우편 확인 메일 발송 기능. 전자우편을 확인하지 않는 경우에 사용할 수 있으나 사용에 제약이 있습니다.</li>
          <li>기기 목록 페이지: 개발됨. 필터 및 정렬은 됩니다. 기기 목록이 상황판 역할을 합니다. 센서의 최신 데이터도 바로 표시되고 실시간으로 변경됩니다.</li>
          <li>기기추가/기기 정보 페이지: 개발됨. 기기 추가하고 변경할 수 있습니다. 기기 삭제는 삭제 예약을 할 수 있고 삭제 예약 취소를 할 수 있습니다.</li>
        </ul>
        <p>로그인하지 않거나 만든 사용자가 아닌 기기 목록/기기 페이지: 일단 보기는 가능하게 해두었습니다. 다른 사용자의 기기 목록이나 기기는 URL로 접근 가능합니다.</p>
        <ul>
          <li> http://data-dev.Tinkable.net/u/pYfVCeMAenSt2QwXwkmBYjtAOre2 : 사용자 ID가 pYfVCeMAenSt2QwXwkmBYjtAOre2의 기기 목록 페이지.</li>
          <li> http://data-dev.Tinkable.net/u/pYfVCeMAenSt2QwXwkmBYjtAOre2/d/uqVGJAJlT9LdZVOmW6JI : 사용자 ID가 pYfVCeMAenSt2QwXwkmBYjtAOre2의 ID가 uqVGJAJlT9LdZVOmW6JI인 기기</li>
          <li> http://data-dev.Tinkable.net/u/pYfVCeMAenSt2QwXwkmBYjtAOre2/d/uqVGJAJlT9LdZVOmW6JI/s/DHTXX : 사용자 ID가 pYfVCeMAenSt2QwXwkmBYjtAOre2의 ID가 uqVGJAJlT9LdZVOmW6JI인 기기 페이지에서 ID가 DHTXX인 센서의 탭이 표시됨.</li>
          <li> 향후 http://data-dev.Tinkable.net/u/d/uqVGJAJlT9LdZVOmW6JI 와 같은 기기 페이지 주소도 지원하고 이 경우 자동으로 http://data-dev.Tinkable.net/u/pYfVCeMAenSt2QwXwkmBYjtAOre2로 toss 합니다.</li>
          <li> 향후 http://data-dev.Tinkable.net/u/d/uqVGJAJlT9LdZVOmW6JI/s/DHTXX 와 같은 기기 페이지 주소도 지원하고 이 경우 자동으로 http://data-dev.Tinkable.net/u/pYfVCeMAenSt2QwXwkmBYjtAOre2s/DHTXX 로 toss 합니다.</li>
        </ul>
    </div>
  </div>
</template>
<script>
  import { mapState } from "vuex"
  import { mapSetter } from "@/plugins/vuexUtils.js"
  export default {
    name: "tinkAbout",
    computed: {
      ...mapSetter(
        mapState({
          presentationMode:  state => state.presentationMode,
        })
      )
    },
    mounted() {
      window.document.body.scrollIntoView(true);
    },
  }
</script>
